class ScrollToHelper {
    static scrollTo(referer = null, additionalSpacing = 0) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        function getTarget() {
            let targetId;

            if (referer.hasAttribute('href')) {
                targetId = referer.getAttribute('href').replace('#', '');
            }

            if (referer.hasAttribute('data-target')) {
                targetId = referer.getAttribute('data-target');
            }

            return targetId;
        }

        const targetId = getTarget();
        const element = document.getElementById(targetId);
        let top = element !== null ? element.getBoundingClientRect().top + scrollTop : 0;

        if (additionalSpacing !== 0) {
            top -= additionalSpacing;
        }

        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top
        });
    }
}

export default ScrollToHelper;
